import React from 'react';
import { Container, Card, ListGroup, Button, NavLink, Row, Col, Carousel } from 'react-bootstrap';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import avatar_motobombas from "../images/avatar_motobombas.png";
import b_bombas_sumergibles_pozos from "../images/b_bombas_sumergibles_pozos.png";
import bsdp_serie_tsa_faboven from "../images/bsdp_serie_tsa_faboven.png";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const Banner = () => {
    return (
        <Card style={{ width: 'w-100', backgroundColor: '#2D4E76' }}>
            <Card.Img variant="top" src={b_bombas_sumergibles_pozos} />
        </Card>
    );
};

const NewContainer = () => {
    return (
        <Container fluid style={{ backgroundColor: '#FFFFFF' }}>
            <Row className="justify-content-center mt-4">
                <Col xs={12} md={2} className="mb-4">
                    <Card border="light">
                        <Carousel>
                            <Carousel.Item>
                                <img className="d-block w-100" src={bsdp_serie_tsa_faboven} alt="bsdp_serie_95pr_panelli" />
                            </Carousel.Item>
                        </Carousel>
                    </Card>
                </Col>
                <Col xs={12} md={3} className="mb-4">
                    <Card border="light">
                        <Card.Body>
                            <Card.Title>Serie TSA Faboven</Card.Title>
                            <Card.Text>
                                Para mayor información comunícate con nosotros.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={3} className="mb-4">
                    <Card border="light">
                        <Card.Body>
                            <ListGroup className="list-group-flush">
                                <ListGroup.Item>Para mayor información comunícate con nosotros.</ListGroup.Item>
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={2} className="mb-4">
                    <Card border="light">
                        <Card.Body>
                            <Card.Title>Descargables</Card.Title>
                            <Card.Text>
                                <Button variant="light" className="m-2"><NavLink href='#'><PictureAsPdfIcon fontSize='large' color='primary' /></NavLink></Button> | <Button variant="light" className="m-2"><NavLink href='#'><PictureAsPdfIcon fontSize='large' color='primary' /></NavLink></Button>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

const Contacto = () => {
    const buttonStyle = {
        backgroundColor: '#2D4E76',
        borderColor: '#2D4E76', // Color del borde
    };

    return (
        <Container className="d-flex justify-content-center" style={{ marginTop: "auto" }}>
            <Button variant="light" className="m-2" style={buttonStyle}>
                <NavLink href="https://wa.me/584244024689">
                    <WhatsAppIcon fontSize="large" style={{ color: '#FAFAFA' }} />
                </NavLink>
            </Button>
            <Button variant="light" className="m-2" style={buttonStyle}>
                <NavLink href="https://instagram.com/motobombasca?igshid=ZDc4ODBmNjlmNQ==">
                    <InstagramIcon fontSize="large" style={{ color: '#FAFAFA' }} />
                </NavLink>
            </Button>
            <Button variant="light" className="m-2" style={buttonStyle}>
                <NavLink href="https://www.google.com/maps/place/Motobombas,+C.A.+Sede+Principal/@10.1984189,-67.9175419,17z/data=!3m1!4b1!4m6!3m5!1s0x8e80679603cd1def:0x897bd1f33654eda4!8m2!3d10.1984189!4d-67.9175419!16s%2Fg%2F11d_9hj8zl">
                    <FmdGoodIcon fontSize="large" style={{ color: '#FAFAFA' }} />
                </NavLink>
            </Button>
        </Container>
    );
};

const Footer = () => {
    return (
        <div
            style={{
                marginTop: "auto", // Hace que el Footer siempre esté al final
                backgroundColor: '#2D4E76',
                color: "#FAFAFA",
                textAlign: "center",
                padding: "10px", // Puedes ajustar el padding según tus necesidades
            }}
        >
            © 2023 Motobombas C.A.
        </div>
    );
};

const SerieTSAFaboven = () => {
    return (
        <div style={{ display: "flex", flexDirection: "column", backgroundColor: "#2D4E76", minHeight: "100vh" }}>
            <Banner />
            <NewContainer />
            <Contacto />
            <Footer />
            <FloatingWhatsApp
                phoneNumber="+584244024689"
                accountName="Motobombas,c.a."
                chatMessage="Hola!, Bienvenido a Motobombas,c.a. ¿Como podemos ayudarte? "
                avatar={avatar_motobombas}
                statusMessage="Fabricantes de Bombas de agua"
            />
        </div>
    );
};

export default SerieTSAFaboven;